import { render, staticRenderFns } from "./LeccionF3.vue?vue&type=template&id=4df4fb30&"
import script from "./LeccionF3.vue?vue&type=script&lang=js&"
export * from "./LeccionF3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports